/* projects/fitnessforservice/src/app/type-a-component/verticalvessel/verticalvessel.component.css */
.hide-scrollbar {
  overflow-y: hidden;
  -ms-overflow-style: hidden;
  scrollbar-width: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
/*# sourceMappingURL=verticalvessel.component-US6XWXMC.css.map */
